import Api from '../Base'

class GetCyclesBySpacePlan extends Api {
  requestUrl = `/api/SpacePlan/${this.getParams().id}/cycles`
}
export default GetCyclesBySpacePlan
